import { gql } from '@apollo/client';

export const SYNC_INVENTORY_UNIT_QR_CODES_ADMIN = gql`
  mutation SyncInventoryUnitQrCodesAdmin(
    $where: LibraryUniqueInput!
    $data: SyncInventoryUnitQrCodesInput
  ) {
    syncInventoryUnitQrCodesAdmin(where: $where, data: $data) {
      message
    }
  }
`;

export const DOWNLOAD_INVENTORY_UNIT_QR_CODES_ADMIN = gql`
  mutation DownloadInventoryUnitQrCodesAdmin(
    $data: DownloadInventoryUnitQrCodesInput!
  ) {
    downloadInventoryUnitQrCodesAdmin(data: $data) {
      data {
        fileUrl
        isBackgroundJob
      }
      message
    }
  }
`;

export const SYNC_INVENTORY_UNIT_QR_CODES = gql`
  mutation SyncInventoryUnitQrCodes($data: SyncInventoryUnitQrCodesInput!) {
    syncInventoryUnitQrCodes(data: $data) {
      message
    }
  }
`;

export const DOWNLOAD_INVENTORY_UNIT_QR_CODES = gql`
  mutation DownloadInventoryUnitQrCodes(
    $data: LibrarianDownloadInventoryUnitQrCodesInput!
  ) {
    downloadInventoryUnitQrCodes(data: $data) {
      data {
        fileUrl
        isBackgroundJob
      }
      message
    }
  }
`;

export const TRANSFER_INVENTORY_UNITS_ADMIN = gql`
  mutation TransferInventoryUnitsAdmin(
    $data: TransferInventoryUnitsAdminInput!
  ) {
    transferInventoryUnitsAdmin(data: $data) {
      message
      data {
        toLibraryId
        movedCount
        results {
          code
          result
          unitId
          fromLibraryId
        }
      }
    }
  }
`;
